<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <div
      id="edituser"
      class="modal fade"
      :class="{ show: show }"
      style="background: rgba(0,0,0,0.5)"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" v-click-outside="onCancel" id="modal">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h5 class="px-2 mb-0">
                {{ $t("edit_vehicle") }}
              </h5>
              <p class="cursor-pointer px-2" @click="onCancel">
                <img src="../../assets/images/Vector (1).png" alt="" />
              </p>
            </div>
            <div
              v-if="mssg"
              align="center"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              align="center"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>
            <form class="p-2" @submit.prevent="editvehicle">
              <div class="form-group">
                <label for="name"> {{ $t("vehicle-name") }}</label>
                <input
                  type="text"
                  name="name"
                  v-model="name"
                  class="form-control"
                  required
                  id="receiver-name"
                  :placeholder="$t('enter-vehicle-name')"
                  @keypress="isLetter($event)"
                />
              </div>

              <div class="form-group">
                <label for="plateNumber"> {{ $t("plate_number") }}</label>
                <input
                  v-model="plateNumber"
                  type="text"
                  name="plateNumber"
                  class="form-control"
                  required
                  id="plateNumber"
                  :placeholder="$t('enter-plate-number')"
                />
              </div>

              <div class="form-group">
                <label for="vehicle"> {{ $t("vehicle-type") }} </label>
                <select
                  v-model="selectedVehicle"
                  name="vehicle"
                  class="form-control"
                  required
                  id="vehicle"
                >
                  <option value="" disabled>{{ $t("select-vehicle") }}</option>
                  <option
                    v-for="vehicle in vehicles"
                    :key="vehicle.id"
                    :value="vehicle.name"
                  >
                    {{ vehicle.name }}
                  </option>
                </select>
              </div>

              <div style="display: flex; justify-content:right;">
                <button type="submit" class="btn btn-primary btn-edit">
                  {{ $t("save") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";

export default {
  name: "EditVehicle",
  components: {
    Loading,
  },

  props: {
    show: Boolean,
    vehicle: Array,
  },

  data() {
    return {
      isLoading: false,
      fullPage: true,

      name: "",
      plateNumber: "",

      mssg: "",
      ErrorPhone: "",
      Errormssg: "",
      selectedVehicle: "",
    };
  },

  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters([]),
    vehicles() {
      return  [
        { id: 1, name: this.$t('truck') },
        { id: 2, name: this.$t('car') },
        { id: 3, name: this.$t('motorcycle') },
      ]
    },
  },

  mounted() {
    this.initialiseForm();
  },
  watch: {
    vehicle: {
      handler: function() {
        this.initialiseForm();
      },
      deep: true,
    },
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  methods: {
    ...mapActions(["editVehicle", "getVehicles"]),
    onCancel() {
      this.$emit("closeEditVehicleModal");
    },
    initialiseForm() {
      setTimeout(() => {
        this.name = this.vehicle[0].name;
        this.plateNumber = this.vehicle[0].plateNumber;
        this.selectedVehicle = this.vehicle[0].type;
      }, 200);
    },
    editvehicle() {
      this.isLoading = true;

      const newVehicle = {
        name: this.name,
        plateNumber: this.plateNumber,
        type: this.selectedVehicle.toLowerCase(),
      };
      this.editVehicle({ newVehicle, id: this.vehicle[0].id })
        .then((res) => {
          this.getVehicles().then(() => {
            this.onCancel();
          });
          this.$emit("showSuccessPopup", {
            msg: this.$t("edited_vehicle_mssg"),
            heading: this.$t("edited_vehicle_heading"),
          });
          this.isLoading = false;
          this.mssg =
            res.data.message[0].toUpperCase() + res.data.message.slice(1);
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
  },
};
</script>

<style scoped>
.modal-dialog {
  max-width: 410px !important;
}
</style>
